module.exports = __webpack_public_path__ + "static/img/icon_title_search.524617f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_title_search.svg
// module id = MAYL
// module chunks = 156